<div class="p-[23px] border-b border-blue-gray-300 flex justify-between items-center">
    <span class="heading-14 font-semibold">Notifications <span
            class="ms-[8px] font-light text-[13px] text-[#8D8D8D] italic">{{ unreadCount }} unread</span></span>
    <a href="#" (click)="markAllAsRead($event)" class="text-emerald-600 heading-14 hover:underline">Mark All as Read</a>
</div>
<div class="overflow-y-auto" [class]="{'max-h-[502px]' : notifications.length > 0}">
    @for (notification of notifications; track notification; let i = $index) {
    <a href="#"
        class="flex flex-col px-[24px] py-[18px] gap-y-[24px] hover:bg-gray-100 hover:cursor-pointer transition ease-in-out duration-150"
        (click)="notificationItemClicked($event, notification)">
        <div class="flex justify-between">
            <div class="flex items-start">
                <div class="grid grid-cols-2 items-center">
                    @if(notification.isUnread) {
                    <span class="h-[8px] w-[8px] rounded-[50%] bg-red-500"></span>
                    }
                    @else {
                    &nbsp;
                    }
                    @if(notification.avatar) {
                    <img [src]="notification.avatar" alt="User Avatar" class="w-[24px] h-[24px] rounded-full mt-[4px]">
                    }
                    @else {
                    <lib-default-profile-icon [classes]="'w-[24px] h-[24px] mt-[4px]'"></lib-default-profile-icon>
                    }
                </div>
                <div class="ml-[8px] flex flex-col gap-y-[6px] w-[320px]">
                    <p class="heading-14 text-gray-500">{{ notification.notificationTypeName }}</p>
                    <div class="heading-12" [innerHTML]="notification.content"></div>
                    <span class="text-[#A8A8A8] text-[10px]">{{ notification.epochDate | epochTimeFormatPipe: 'DD MMMM YYYY' }}</span>
                </div>
            </div>
            <div
              class="relative flex items-center justify-center rounded-full hover:bg-gray-300 transition duration-150 w-[32px] h-[32px]"
              (click)="removeNotification($event, i)">
                <lib-close-icon></lib-close-icon>
            </div>
        </div>
    </a>
    }
</div>
